/* ============================================================
   BONEANTHONY — Collection page JS (Dossier-style)
   Loaded by: sections/main-collection-product-grid.liquid

   Handles:
     - Push-sidebar toggle (SORT & FILTER button → .is-open on layout)
     - Body scroll lock on mobile when sidebar open
     - ESC closes sidebar
     - Reveal-on-scroll for product cells
     - Infinite scroll (when section's data-pagination-mode = 'infinite')
   ============================================================ */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // --------------------------------------------------------
  // Push sidebar toggle
  // --------------------------------------------------------
  function initSidebar(section) {
    var trigger = $('[data-ba-pg-trigger]', section);
    var layout  = $('[data-ba-pg-layout]', section);
    var sidebar = $('[data-ba-pg-sidebar]', section);
    var closeBtn = $('[data-ba-pg-close]', section);
    var backdrop = $('[data-ba-pg-backdrop]', section);
    if (!trigger || !layout || !sidebar) return;

    var lastFocus = null;

    function isPhone() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function open() {
      lastFocus = document.activeElement;
      layout.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      sidebar.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      // Lock body scroll on phone (sidebar is full-screen overlay there)
      if (isPhone()) {
        document.body.classList.add('ba-pg-filter-open');
      }
      // Move focus into the drawer for keyboard users
      var firstFocus = sidebar.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocus) {
        setTimeout(function () { firstFocus.focus(); }, 60);
      }
    }

    function close() {
      layout.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      sidebar.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('ba-pg-filter-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function toggle() {
      if (layout.classList.contains('is-open')) close();
      else open();
    }

    trigger.addEventListener('click', toggle);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && layout.classList.contains('is-open')) {
        close();
        trigger.focus();
      }
    });

    // Reset body scroll lock if viewport switches between phone and tablet/desktop
    var lastPhoneState = isPhone();
    window.addEventListener('resize', function () {
      var nowPhone = isPhone();
      if (lastPhoneState !== nowPhone && layout.classList.contains('is-open')) {
        if (nowPhone) document.body.classList.add('ba-pg-filter-open');
        else document.body.classList.remove('ba-pg-filter-open');
      }
      lastPhoneState = nowPhone;
    });
  }

  // --------------------------------------------------------
  // Reveal-on-scroll
  // --------------------------------------------------------
  function initReveal(section) {
    var els = $all('[data-ba-anim]:not(.is-visible)', section);
    if (els.length === 0) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  // --------------------------------------------------------
  // Infinite scroll (if data-pagination-mode = 'infinite')
  // --------------------------------------------------------
  function initInfiniteScroll(section) {
    if (section.dataset.paginationMode !== 'infinite') return;

    function bind() {
      var trigger = $('[data-ba-pg-infinite]', section);
      if (!trigger || trigger.dataset.bound === '1') return;
      trigger.dataset.bound = '1';

      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            obs.disconnect();
            loadNext(trigger);
          }
        });
      }, { rootMargin: '400px 0px' });
      obs.observe(trigger);
    }

    function loadNext(trigger) {
      var url = trigger.getAttribute('href');
      if (!url) return;
      trigger.textContent = 'Loading more…';

      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextSection = doc.querySelector('[data-ba-pg]');
          if (!nextSection) return;

          var newGrid = nextSection.querySelector('[data-ba-pg-grid]');
          var currentGrid = section.querySelector('[data-ba-pg-grid]');
          if (newGrid && currentGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (cell) {
              currentGrid.appendChild(cell);
            });
          }

          var newWrap = nextSection.querySelector('.ba-pg__pagination-wrap');
          var currentWrap = section.querySelector('.ba-pg__pagination-wrap');
          if (currentWrap) {
            if (newWrap) currentWrap.replaceWith(newWrap);
            else currentWrap.remove();
          }

          initReveal(section);
          bind();
        })
        .catch(function () {
          trigger.textContent = 'Try again';
        });
    }

    bind();
  }

  // --------------------------------------------------------
  // Quick add to cart — AJAX submit + live header cart count update
  //
  // We don't use Dawn's <product-form> because it requires a
  // cart-notification or cart-drawer element on the page (which we
  // don't render yet). Instead, hijack the form submit, POST to
  // /cart/add.js, then refresh the header cart count from /cart.js.
  // --------------------------------------------------------
  function updateHeaderCartCount(count) {
    $all('.ba-header__cart-count').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    $all('.ba-header__icon-btn--cart').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
    // Dispatch a custom event so any other listeners can react
    document.dispatchEvent(new CustomEvent('ba:cart:updated', { detail: { count: count } }));
  }

  function flashButton(btn, msg, restoreMs) {
    var span = btn.querySelector('span');
    if (!span) return;
    var orig = span.textContent;
    span.textContent = msg;
    setTimeout(function () { span.textContent = orig; }, restoreMs || 1500);
  }

  function initQuickAdd(scope) {
    // Default scope = whole document so this works on any section that
    // renders [data-ba-quick-add] forms (collection page, featured
    // collection on homepage, etc.).
    scope = scope || document;
    var forms = $all('[data-ba-quick-add]', scope);
    forms.forEach(function (form) {
      // Avoid double-binding when re-initialised from shopify:section:load
      if (form.dataset.baBound === '1') return;
      form.dataset.baBound = '1';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.ba-ccard__add-btn');
        if (!btn || btn.disabled) return;

        btn.disabled = true;
        var span = btn.querySelector('span');
        var origText = span ? span.textContent : '';
        if (span) span.textContent = 'Adding…';

        var formData = new FormData(form);

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok || (res.data.status && res.data.status >= 400)) {
              if (span) span.textContent = res.data.message || 'Could not add';
              setTimeout(function () {
                if (span) span.textContent = origText;
                btn.disabled = false;
              }, 1800);
              return;
            }
            // Success — fetch cart to get current item count
            return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                updateHeaderCartCount(cart.item_count);
                // Fire ba:cart:added so the cart drawer auto-opens with
                // the new item visible (mirrors ba-product-form.js:279
                // which fires the same event from PDP add-to-cart). The
                // drawer listens via document.addEventListener('ba:cart:added')
                // in ba-cart-drawer.js. Without this dispatch, the count
                // updates silently but the drawer stays closed.
                document.dispatchEvent(new CustomEvent('ba:cart:added', {
                  detail: { cart: cart, source: 'quick-add' },
                  bubbles: true
                }));
                if (span) span.textContent = 'Added';
                setTimeout(function () {
                  if (span) span.textContent = origText;
                  btn.disabled = false;
                }, 1500);
              });
          })
          .catch(function (err) {
            console.error('[ba-quick-add]', err);
            if (span) span.textContent = origText;
            btn.disabled = false;
          });
      });
    });
  }

  // --------------------------------------------------------
  // Section init
  // --------------------------------------------------------
  function initSection(section) {
    initSidebar(section);
    initReveal(section);
    initInfiniteScroll(section);
  }

  function init() {
    $all('[data-ba-pg]').forEach(initSection);
    // Quick-add scans globally so it works in featured-collection,
    // collection grid, related products, anywhere a form has data-ba-quick-add.
    initQuickAdd(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when section reloaded in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!sec) return;
    var pg = sec.querySelector('[data-ba-pg]');
    if (pg) initSection(pg);
    // Always re-scan for any quick-add forms in the reloaded section
    initQuickAdd(sec);
  });
})();
